import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button } from '../../styled-components';
import { actions as axisOrderActions } from '../../actions/axisOrder';
import { localizeAxis as localize } from '../../util/localizeUtils';

const Container = styled.div`
  flex: 0 0 auto;
  width: 100%;
  padding: 0.25rem;
`;

const Message = styled.div`
  color: red;
`;

const ButtonContainer = styled.div`
  text-align: right;
  > button {
    margin-left: .25rem;
  }
`;

class Footer extends Component {
  componentDidUpdate() {
    if (this.props.message.includes(this.props.orderId.toString())) {
      setTimeout(() => {
        this.props.clearOrderId();
      }, 10000);
    }
  }
  render() {
    return (
      <Container>
        <Message ref={div => { this.messageContainer = div; }}>{this.props.message}</Message>
        <ButtonContainer>
          <Button onClick={this.props.onSubmit}>{localize('submitButton')}</Button>
        </ButtonContainer>
      </Container>
    );
  }
}

Footer.defaultProps = {
  onSubmit: () => {},
  message: '',
  orderId: -1
};

Footer.propTypes = {
  clearOrderId: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  message: PropTypes.string,
  orderId: PropTypes.number
};

const mapStateToProps = (state) => {
  const errorMessage = state.axisOrder.errorMessage;
  const hiddenMessage = state.axisOrder.isValidating ? state.axisOrder.hiddenMessage : '';
  const successMessage = state.axisOrder.successMessage;
  let message = '';
  if (errorMessage) {
    message = errorMessage;
  } else if (hiddenMessage) {
    message = hiddenMessage;
  } else if (successMessage) {
    message = successMessage;
  }
  return {
    message,
    orderId: state.axisOrder.orderId
  };
};

const mapDispatchToProps = {
  clearOrderId: axisOrderActions.clearOrderId
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);



// WEBPACK FOOTER //
// ./app/components/OrderForm/Footer.js